import { gql } from "@apollo/client";

export const GET_IT_APPLICATION_NAME = gql`
  query GetItApplicationName($applicationUUID: ID!) {
    findItApplication(uuid: $applicationUUID) {
      application
    }
  }
`;